import { cn } from "@/lib/utils";

interface LegendaryGlowProps {
  isLegendary: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  children: React.ReactNode;
  className?: string;
}

const sizeClasses = {
  sm: 'before:inset-[-3px] before:blur-[4px]',
  md: 'before:inset-[-4px] before:blur-[5px]',
  lg: 'before:inset-[-5px] before:blur-[6px]',
  xl: 'before:inset-[-6px] before:blur-[8px]',
};

export function LegendaryGlow({ 
  isLegendary, 
  size = 'sm',
  children,
  className 
}: LegendaryGlowProps) {
  if (!isLegendary) {
    return <>{children}</>;
  }

  return (
    <div className={cn(
      "relative",
      className
    )}>
      {/* Animated glow ring */}
      <div 
        className={cn(
          "absolute rounded-full z-0",
          "before:absolute before:rounded-full before:content-['']",
          "before:bg-gradient-to-r before:from-amber-400 before:via-yellow-300 before:to-orange-400",
          "before:animate-pulse",
          sizeClasses[size]
        )}
        style={{
          inset: size === 'sm' ? '-3px' : size === 'md' ? '-4px' : size === 'lg' ? '-5px' : '-6px',
          background: 'linear-gradient(135deg, hsl(45 100% 60%), hsl(35 100% 55%), hsl(45 100% 65%))',
          filter: size === 'sm' ? 'blur(4px)' : size === 'md' ? 'blur(5px)' : size === 'lg' ? 'blur(6px)' : 'blur(8px)',
          animation: 'legendary-pulse 2s ease-in-out infinite',
        }}
      />
      {/* Outer subtle ring */}
      <div 
        className="absolute rounded-full z-0"
        style={{
          inset: size === 'sm' ? '-5px' : size === 'md' ? '-6px' : size === 'lg' ? '-8px' : '-10px',
          background: 'linear-gradient(135deg, hsl(45 100% 70% / 0.4), hsl(35 100% 60% / 0.3))',
          filter: size === 'sm' ? 'blur(6px)' : size === 'md' ? 'blur(8px)' : size === 'lg' ? 'blur(10px)' : 'blur(12px)',
          animation: 'legendary-pulse 2s ease-in-out infinite 0.5s',
        }}
      />
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
